import React from 'react';
import styles from './PasswordStrength.module.css';
import { getPasswordStrength } from '../../utils/validation';

function PasswordStrength({ password }) {
  const strength = getPasswordStrength(password);

  if (!password) return null;

  return (
    <div className={styles.container}>
      <div className={styles.bar}>
        <div
          className={styles.fill}
          style={{
            width: `${strength.percentage}%`,
            backgroundColor: strength.color,
          }}
        />
      </div>
      <span className={styles.label} style={{ color: strength.color }}>
        {strength.label}
      </span>
    </div>
  );
}

export default PasswordStrength;
